import { defaultIconProps, IconProps } from 'components/Icons/IconProps';

export const IconLines: import('react').FC<IconProps> = ({ size, color = '#667085', ...rest }) => (
  <svg data-testid="icon-lines" width={size} height={size} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M3 5H11M1 1H13M5 9H9" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconLines.defaultProps = defaultIconProps;
